
// Shared initialization function
function initializeSubscriptionUI() {
  /** @type {HTMLElement | null} */
  // Only target the main product page selling plans container (inside product-form-component)
  const productForm = document.querySelector('product-form-component');
  if (!productForm) return false;

  const sellingPlansContainer = productForm.querySelector('.rc-selling-plans');

  if (sellingPlansContainer && !sellingPlansContainer.querySelector('#vue-app')) {
    const div = document.createElement('div');
    div.id = 'vue-app';
    sellingPlansContainer.appendChild(div);

    // Get asset URLs from script data attributes for proper cache busting
    const scriptEl = document.querySelector('script[data-product-purchase-types-url]');
    const productPurchaseTypesUrl = scriptEl?.dataset.productPurchaseTypesUrl || '/assets/ProductPurchaseTypes.js';
    const floatingCtaUrl = scriptEl?.dataset.floatingCtaUrl || '/assets/FloatingCTA.js';

    const script1 = document.createElement('script');
    script1.type = 'module';
    script1.src  = productPurchaseTypesUrl;
    sellingPlansContainer.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'module';
    script2.src  = floatingCtaUrl;
    sellingPlansContainer.appendChild(script2);

    addPopupElement();
    replaceRadioInputElements();

    return true;
  }
  return false;
}

// Listen for Recharge loaded event for instant initialization
window.addEventListener('recharge:loaded', () => {
  setTimeout(initializeSubscriptionUI, 0);
});

// Try immediately on script load (Recharge may have already loaded)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeSubscriptionUI();
  });
} else {
  initializeSubscriptionUI();
}

// @ts-ignore
export async function mutationObserverCallback(mutationList, observer) {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      if (initializeSubscriptionUI()) {
        observer.disconnect();
      }
    }
  }
}


function addPopupElement() {
  /** @type {HTMLElement | null} */
  const popupContentEl = document.querySelector('.rc_popup .rc_popup__block');
  if (!popupContentEl) return;
  popupContentEl.className = 'popup_block';

  const selectorStr = '.rc-radio-group__options .rc-radio.rc-option__subsave';
  const subscriptionEl = document.querySelector(selectorStr);
  const div = document.createElement('div');
  div.className = 'popup-element';
  div.textContent = '?';
  div.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const popupEl = document.querySelector('.popup_block');
    popupEl?.classList.toggle('show_popup');
    document.body.addEventListener('click', () => popupEl?.classList.toggle('show_popup'), { once: true })
  });
  subscriptionEl?.appendChild(div);
  subscriptionEl?.appendChild(popupContentEl.cloneNode(true));
}


function replaceRadioInputElements() {
  /** @type {NodeListOf<HTMLElement>|null} */
  const purchaseTypeOptionEls = document.querySelectorAll('.rc-radio.rc-option.rc_widget__option');
  purchaseTypeOptionEls?.forEach((el) => {
    if (!el) return;
    const replacementEl = el.querySelector('.radio-button-outer-circle');
    if (replacementEl) return;
    const firstChild = el.firstElementChild;
    const div = document.createElement('div');
    div.className = 'radio-button-outer-circle';
    div.innerHTML = `<div class="radio-button-inner-circle" />`;
    el.insertBefore(div, firstChild);
  });
}